// WEL-5195: destinos de navegação a partir de um evento da Timeline.
//
// Compartilhado entre a Timeline (botoes de icone no card do evento) e o
// painel de detalhes do ModalTimeline, para que a regra de "esse evento da
// pra abrir em campanha/relatorio?" seja a mesma nos dois lugares.
//
// WEL-5195: o relatorio, sem periodo explicito, assume "Hoje" no backend
// (RelatorioController::obterDadosDetalhado, fallback `$periodo = ... :
// 'HJ'`). Por isso a URL do relatorio carrega tambem a data do evento —
// sem ela, um evento de qualquer dia anterior chegava lá e não aparecia.

import moment from "moment";
//
// O que cada destino precisa e diferente:
// - campanha: só o nome, porque a listagem de automação filtra por nome.
//   Importa porque agendamento futuro vem da branch de cron, que zera o
//   modelo_campanha_id — exigir id bloquearia justamente esses eventos.
// - relatorio: o id, que e o que o filtro de campanha de la usa.
//
// Desconexão de WhatsApp/agente e envio de integração não têm nem um nem
// outro (modelo "-"), então ficam sem destino nos dois casos.

export const DESTINOS = {
  campanha: {
    chave: "campanha",
    rotulo: "Ver Campanha",
    rotuloCurto: "Campanha",
    icone: "fa-bullhorn",
    titulo: "Abrir a campanha"
  },
  relatorio: {
    chave: "relatorio",
    rotulo: "Ver Relatório",
    rotuloCurto: "Relatório",
    icone: "fa-chart-column",
    titulo: "Abrir o relatório detalhado"
  }
};

export function nomeCampanha(evento) {
  const nome = evento && evento.modelo;
  return nome && nome !== "-" ? nome : "";
}

export function temDestino(evento, destino) {
  if (!evento) return false;

  if (destino === "campanha") {
    return !!nomeCampanha(evento);
  }

  // Sem quantidade não há nada pra ver no relatório — levar o usuário pra
  // la so mostraria uma lista vazia, parecendo bug em vez de comportamento
  // esperado.
  return Number(evento.modelo_campanha_id) > 0 && Number(evento.quantidade) > 0;
}

export function urlDestino(evento, destino) {
  if (destino === "campanha") {
    return `/painel/automacao?campanhaNome=${encodeURIComponent(
      nomeCampanha(evento)
    )}`;
  }

  // Query (e não params): a personificação recarrega a página e params de
  // rota não sobrevivem ao reload.
  const id = Number(evento.modelo_campanha_id);
  const nome = encodeURIComponent(nomeCampanha(evento));
  const data = encodeURIComponent(moment(evento.data).format("YYYY-MM-DD"));
  return `/painel/relatorio/detalhado?campanhaId=${id}&campanhaNome=${nome}&data=${data}`;
}
